(function () {
  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function directElements(root) {
    return Array.prototype.slice.call(root.children || []).filter(function (node) {
      return node && node.nodeType === 1;
    });
  }

  function parseSpecList(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('li'));
    var parsed = items.map(function (li) {
      var text = (li.textContent || '').replace(/\s+/g, ' ').trim();
      var idx = text.indexOf(':');
      if (idx < 1) return null;
      var label = text.slice(0, idx).trim();
      var value = text.slice(idx + 1).trim();
      if (!label || !value) return null;
      return { label: label, value: value };
    }).filter(Boolean);
    return parsed.length >= 4 ? parsed : null;
  }

  function buildSpecs(parsed) {
    var shell = document.createElement('section');
    shell.className = 'cwt-enhanced-specs';

    var heading = document.createElement('h3');
    heading.className = 'cwt-enhanced-heading';
    heading.textContent = 'Item Specifics';
    shell.appendChild(heading);

    var grid = document.createElement('div');
    grid.className = 'cwt-enhanced-specs__grid';

    parsed.forEach(function (row) {
      var item = document.createElement('div');
      item.className = 'cwt-enhanced-specs__row';

      var label = document.createElement('div');
      label.className = 'cwt-enhanced-specs__label';
      label.textContent = row.label;

      var value = document.createElement('div');
      value.className = 'cwt-enhanced-specs__value';
      value.textContent = row.value;

      item.appendChild(label);
      item.appendChild(value);
      grid.appendChild(item);
    });

    shell.appendChild(grid);
    return shell;
  }

  function makeCard(title, nodes) {
    if (!nodes || !nodes.length) return null;
    var card = document.createElement('section');
    card.className = 'cwt-rich-card';

    var heading = document.createElement('h3');
    heading.className = 'cwt-rich-card__title';
    heading.textContent = title;
    card.appendChild(heading);

    nodes.forEach(function (node) {
      card.appendChild(node);
    });
    return card;
  }

  function enhanceDescriptionContent(content) {
    if (!content || content.dataset.cwtEnhanced === 'true') return;

    var tab = content.closest('.tab-content');
    var titleNode = tab ? tab.querySelector('.toggle-title .text') : null;
    var title = normalize(titleNode ? titleNode.textContent : '');
    if (title && !/about this item|description/.test(title)) return;

    content.dataset.cwtEnhanced = 'true';
    content.classList.add('cwt-rich-description');

    /* Many product descriptions are wrapped in a .rte div. Work inside that
       wrapper so lists/headings are visible to the enhancer. */
    var source = content.querySelector(':scope > .rte') || content.querySelector('.rte') || content;
    var children = directElements(source);
    if (!children.length) return;

    /* Collectors World Toys structured HTML support.
       Product descriptions may be pasted with semantic wrappers such as
       .cwt-item-specifics, .cwt-about-item, .cwt-condition and
       .cwt-why-collect. Convert those directly into the catalog layout and
       discard their internal H2 headings so the theme does not duplicate or
       oversize them. */
    var structured = source.querySelector('.cwt-product-description');
    if (structured) {
      var specSection = structured.querySelector('.cwt-item-specifics');
      var aboutSection = structured.querySelector('.cwt-about-item');
      var conditionSection = structured.querySelector('.cwt-condition');
      var whySection = structured.querySelector('.cwt-why-collect');

      var structuredSpecs = null;
      if (specSection) {
        var structuredList = specSection.querySelector('ul');
        var structuredParsed = structuredList ? parseSpecList(structuredList) : null;
        if (structuredParsed) structuredSpecs = buildSpecs(structuredParsed);
      }

      function sectionNodes(section) {
        if (!section) return [];
        return directElements(section).filter(function (node) {
          return !/^h[1-6]$/i.test(node.tagName || '');
        });
      }

      var structuredCards = [];
      var structuredAbout = makeCard('About This Item', sectionNodes(aboutSection));
      var structuredCondition = makeCard('Condition', sectionNodes(conditionSection));
      var structuredWhy = makeCard('Why Collect This Model', sectionNodes(whySection));
      if (structuredAbout) structuredCards.push(structuredAbout);
      if (structuredCondition) structuredCards.push(structuredCondition);
      if (structuredWhy) structuredCards.push(structuredWhy);

      if (structuredSpecs || structuredCards.length) {
        while (source.firstChild) source.removeChild(source.firstChild);
        if (structuredSpecs) source.appendChild(structuredSpecs);
        if (structuredCards.length) {
          var structuredWrap = document.createElement('div');
          structuredWrap.className = 'cwt-rich-description__cards';
          structuredCards.forEach(function (card) { structuredWrap.appendChild(card); });
          source.appendChild(structuredWrap);
        }
        return;
      }
    }

    /* Detect Vehicle Details / spec list anywhere in the description. */
    var specList = null;
    var parsedSpecs = null;
    var lists = Array.prototype.slice.call(source.querySelectorAll('ul'));
    lists.some(function (list) {
      var parsed = parseSpecList(list);
      if (parsed) {
        specList = list;
        parsedSpecs = parsed;
        return true;
      }
      return false;
    });

    var specsBlock = parsedSpecs ? buildSpecs(parsedSpecs) : null;
    if (specsBlock) {
      source.insertBefore(specsBlock, source.firstChild);
      specList.classList.add('cwt-specs-source');

      /* Hide a nearby plain-text Vehicle Details label so it isn't duplicated. */
      var prev = specList.previousElementSibling;
      if (prev && /^(vehicle details|product details|item specifics)$/i.test((prev.textContent || '').trim())) {
        prev.classList.add('cwt-specs-source');
      }
    }

    var remaining = directElements(source).filter(function (el) {
      return !el.classList.contains('cwt-enhanced-specs') && !el.classList.contains('cwt-specs-source');
    });
    if (!remaining.length) return;

    var markerNames = {
      'why collect this model': 'Why Collect This Model',
      'condition': 'Condition',
      'collector notes': 'Collector Notes'
    };

    var intro = [];
    var buckets = {
      'why collect this model': [],
      'condition': [],
      'collector notes': []
    };
    var current = null;

    remaining.forEach(function (el) {
      var text = normalize(el.textContent);
      if (markerNames[text]) {
        current = text;
        el.remove();
        return;
      }
      if (current) buckets[current].push(el);
      else intro.push(el);
    });

    var cards = [];
    var about = makeCard('About This Item', intro);
    if (about) cards.push(about);
    var condition = makeCard('Condition', buckets['condition']);
    if (condition) cards.push(condition);
    var why = makeCard('Why Collect This Model', buckets['why collect this model']);
    if (why) cards.push(why);
    var notes = makeCard('Collector Notes', buckets['collector notes']);
    if (notes) cards.push(notes);

    if (!cards.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'cwt-rich-description__cards';
    cards.forEach(function (card) { wrap.appendChild(card); });

    directElements(source).forEach(function (child) {
      if (child !== specsBlock) child.remove();
    });
    source.appendChild(wrap);
  }


  function syncMobileDetailAccordions() {
    var content = document.querySelector('.section-product-tabs .cwt-rich-description');
    if (!content) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    function wrapSection(section, label, openDefault) {
      if (!section || section.parentElement && section.parentElement.classList.contains('cwt-mobile-only-accordion__panel')) return;

      var details = document.createElement('details');
      details.className = 'cwt-mobile-only-accordion';
      if (openDefault) details.open = true;

      var summary = document.createElement('summary');
      summary.textContent = label;

      var panel = document.createElement('div');
      panel.className = 'cwt-mobile-only-accordion__panel';

      section.parentNode.insertBefore(details, section);
      panel.appendChild(section);
      details.appendChild(summary);
      details.appendChild(panel);
    }

    function unwrapAll() {
      content.querySelectorAll('.cwt-mobile-only-accordion').forEach(function (details) {
        var panel = details.querySelector(':scope > .cwt-mobile-only-accordion__panel');
        if (!panel) return;
        var child = panel.firstElementChild;
        if (child) details.parentNode.insertBefore(child, details);
        details.remove();
      });
    }

    if (!isMobile) {
      unwrapAll();
      return;
    }

    var specs = content.querySelector('.cwt-enhanced-specs');
    if (specs) wrapSection(specs, 'Item Specifics', true);

    content.querySelectorAll('.cwt-rich-card').forEach(function (card) {
      var heading = card.querySelector(':scope > .cwt-rich-card__title');
      var label = heading ? heading.textContent.trim() : 'Details';
      wrapSection(card, label, false);
    });
  }


  function stretchTrustBlock() {
    var trust = document.querySelector('.main-product-information .product-details .cwt-product-trust');
    if (!trust) return;

    trust.style.setProperty('width', '100%', 'important');
    trust.style.setProperty('max-width', 'none', 'important');
    trust.style.setProperty('min-width', '0', 'important');
    trust.style.setProperty('box-sizing', 'border-box', 'important');
    trust.style.setProperty('align-self', 'stretch', 'important');

    var node = trust.parentElement;
    while (node && !node.classList.contains('product-details')) {
      node.style.setProperty('width', '100%', 'important');
      node.style.setProperty('max-width', 'none', 'important');
      node.style.setProperty('min-width', '0', 'important');
      node.style.setProperty('box-sizing', 'border-box', 'important');
      node.style.setProperty('align-self', 'stretch', 'important');
      node.style.setProperty('flex-basis', '100%', 'important');
      node = node.parentElement;
    }
  }



  function forceImportant(el, prop, value) {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function fixPurchaseControls() {
    var details = document.querySelector('.main-product-information .product-details');
    if (!details) return;

    var formButtons = details.querySelector('.product-form__buttons');
    if (!formButtons) return;

    var quantity = formButtons.querySelector('.product-form__quantity');
    var outerCart = formButtons.querySelector(':scope > .add-to-cart-button-container');

    forceImportant(formButtons, 'display', 'flex');
    forceImportant(formButtons, 'flex-direction', 'column');
    forceImportant(formButtons, 'align-items', 'stretch');
    forceImportant(formButtons, 'width', '100%');
    forceImportant(formButtons, 'max-width', 'none');
    forceImportant(formButtons, 'gap', '10px');

    if (quantity) {
      forceImportant(quantity, 'display', 'block');
      forceImportant(quantity, 'width', '100%');
      forceImportant(quantity, 'max-width', 'none');
      forceImportant(quantity, 'margin', '0');
      forceImportant(quantity, 'order', '1');

      var qtyLabel = quantity.querySelector('.quantity__label');
      if (qtyLabel) {
        forceImportant(qtyLabel, 'display', 'block');
        forceImportant(qtyLabel, 'width', '100%');
        forceImportant(qtyLabel, 'text-align', 'left');
        forceImportant(qtyLabel, 'margin', '0 0 7px');
      }

      var qtyContainer = quantity.querySelector('.price-per-item__container');
      if (qtyContainer) {
        forceImportant(qtyContainer, 'display', 'flex');
        forceImportant(qtyContainer, 'justify-content', 'flex-start');
        forceImportant(qtyContainer, 'width', '100%');
        forceImportant(qtyContainer, 'max-width', 'none');
      }

      var qtyInput = quantity.querySelector('quantity-input.quantity');
      if (qtyInput) {
        forceImportant(qtyInput, 'width', '142px');
        forceImportant(qtyInput, 'min-width', '142px');
        forceImportant(qtyInput, 'max-width', '142px');
      }
    }

    if (outerCart) {
      forceImportant(outerCart, 'display', 'block');
      forceImportant(outerCart, 'width', '100%');
      forceImportant(outerCart, 'max-width', 'none');
      forceImportant(outerCart, 'min-width', '0');
      forceImportant(outerCart, 'order', '2');
      forceImportant(outerCart, 'flex', '0 0 auto');

      var inner = outerCart.querySelector(':scope > .add-to-cart-button-inner');
      if (inner) {
        forceImportant(inner, 'display', 'grid');
        forceImportant(inner, 'grid-template-columns', '44px 44px minmax(0, 1fr)');
        forceImportant(inner, 'gap', '8px');
        forceImportant(inner, 'width', '100%');
        forceImportant(inner, 'max-width', 'none');
        forceImportant(inner, 'align-items', 'stretch');

        var actualCartWrap = inner.querySelector(':scope > .add-to-cart-button-container');
        if (actualCartWrap) {
          forceImportant(actualCartWrap, 'grid-column', '1 / -1');
          forceImportant(actualCartWrap, 'grid-row', '1');
          forceImportant(actualCartWrap, 'display', 'block');
          forceImportant(actualCartWrap, 'width', '100%');
          forceImportant(actualCartWrap, 'max-width', 'none');
          forceImportant(actualCartWrap, 'min-width', '0');
          forceImportant(actualCartWrap, 'margin', '0');

          var button = actualCartWrap.querySelector('button[name="add"]');
          if (button) {
            forceImportant(button, 'display', 'flex');
            forceImportant(button, 'width', '100%');
            forceImportant(button, 'max-width', 'none');
            forceImportant(button, 'min-width', '0');
            forceImportant(button, 'min-height', '52px');
            forceImportant(button, 'justify-content', 'center');
            forceImportant(button, 'align-items', 'center');
          }
        }

        var utilities = inner.querySelectorAll(':scope > .card-product__group-item');
        utilities.forEach(function (utility, index) {
          forceImportant(utility, 'grid-row', '2');
          forceImportant(utility, 'grid-column', String(index + 1));
          forceImportant(utility, 'width', '44px');
          forceImportant(utility, 'min-width', '44px');
          forceImportant(utility, 'max-width', '44px');
          forceImportant(utility, 'height', '44px');
          forceImportant(utility, 'min-height', '44px');
          forceImportant(utility, 'margin', '0');
          forceImportant(utility, 'justify-self', 'start');
        });
      }
    }
  }

  function normalizeSoldOutNotify() {
    var details = document.querySelector('.main-product-information .product-details');
    if (!details) return;

    details.querySelectorAll('button[name="add"][disabled]').forEach(function (button) {
      var label = (button.textContent || '').trim().toLowerCase();
      if (label.indexOf('sold out') !== -1 || label.indexOf('unavailable') !== -1) {
        button.classList.add('cwt-sold-out-button');
        forceImportant(button, 'display', 'flex');
        forceImportant(button, 'width', '100%');
        forceImportant(button, 'max-width', 'none');
        forceImportant(button, 'min-width', '0');
        forceImportant(button, 'min-height', '50px');
        forceImportant(button, 'align-items', 'center');
        forceImportant(button, 'justify-content', 'center');
        forceImportant(button, 'background', '#eef2f5');
        forceImportant(button, 'border', '1px solid #d7dee6');
        forceImportant(button, 'color', '#5b6875');
        forceImportant(button, 'box-shadow', 'none');
        forceImportant(button, 'opacity', '1');
        forceImportant(button, 'cursor', 'not-allowed');
      }
    });

    details.querySelectorAll('button, a').forEach(function (control) {
      var label = (control.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!label || label.indexOf('notify') === -1) return;
      if (label.indexOf('available') === -1 && label.indexOf('stock') === -1 && label !== 'notify me') return;

      control.classList.add('cwt-notify-button');
      forceImportant(control, 'display', 'flex');
      forceImportant(control, 'width', '100%');
      forceImportant(control, 'max-width', 'none');
      forceImportant(control, 'min-width', '0');
      forceImportant(control, 'min-height', '50px');
      forceImportant(control, 'align-items', 'center');
      forceImportant(control, 'justify-content', 'center');
      forceImportant(control, 'align-self', 'stretch');
      forceImportant(control, 'margin-left', '0');
      forceImportant(control, 'margin-right', '0');
      forceImportant(control, 'box-sizing', 'border-box');

      var node = control.parentElement;
      var depth = 0;
      while (node && node !== details && depth < 5) {
        node.classList.add('cwt-notify-wrap');
        forceImportant(node, 'width', '100%');
        forceImportant(node, 'max-width', 'none');
        forceImportant(node, 'min-width', '0');
        forceImportant(node, 'align-self', 'stretch');
        forceImportant(node, 'box-sizing', 'border-box');
        if (node.matches('form, .back-in-stock-alert, .shopify-block, [data-block-id]')) break;
        node = node.parentElement;
        depth += 1;
      }
    });
  }

  function watchPurchaseControls() {
    var details = document.querySelector('.main-product-information .product-details');
    if (!details || details.dataset.cwtControlsObserver === 'true') return;
    details.dataset.cwtControlsObserver = 'true';

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fixPurchaseControls();
        stretchTrustBlock();
        normalizeSoldOutNotify();
      });
    });
    observer.observe(details, { childList: true, subtree: true });
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;
    document.querySelectorAll('.section-product-tabs .tab-content .toggle-content').forEach(enhanceDescriptionContent);
    syncMobileDetailAccordions();
    stretchTrustBlock();
    fixPurchaseControls();
    normalizeSoldOutNotify();
    watchPurchaseControls();
    window.setTimeout(function () { fixPurchaseControls(); stretchTrustBlock(); normalizeSoldOutNotify(); }, 150);
    window.setTimeout(function () { fixPurchaseControls(); stretchTrustBlock(); normalizeSoldOutNotify(); }, 600);

    if (!window.__cwtDetailAccordionResizeBound) {
      window.__cwtDetailAccordionResizeBound = true;
      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(syncMobileDetailAccordions, 120);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
